import React from 'react'
import { Text, TextProps } from '@nominex/dex-uikit'
import { SlSkeleton } from '@shoelace-style/shoelace/dist/react'

type LoadableValueProps = TextProps & {
  loading: boolean
  height?: string
  width?: string
  children?: any
}

const LoadableValue: React.FC<LoadableValueProps> = ({
  loading,
  children,
  height = '20px',
  width = '60px',
  ...props
}) =>
  loading ? (
    <SlSkeleton style={{ height, width }} effect="sheen" />
  ) : (
    // TODO: should be replaced with span
    <Text {...props} lineHeight="1" noTranslate>
      {children}
    </Text>
  )

export default LoadableValue
